import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";

export class Section extends EntityDto implements IEntityDto {
    Section_Id: string;
    SectionName: string; 
    Act_Id: string;
    ActName: string;
    TotalCount: number;
    IsActive: boolean;
    
    constructor() {
        super();
        this.Section_Id = "00000000-0000-0000-0000-000000000000";
        this.SectionName = "";
        this.Act_Id = "";
        this.ActName = ""; 
        this.TotalCount = 0; 
        this.IsActive = true;

        this.EntityMetaData = [
            { FieldName: 'SectionName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Section Name is required' },
            //{ FieldName: 'Act_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Act is required' },
        ];
    }
}
